import {ID, KTIcon} from '../../../../_metronic/helpers'
import {useMutation, useQueryClient} from 'react-query'
import {useFormik} from 'formik'
import ReactSelectBox from '../../../utils/components/ReactSelectBox'
import {IRouteSenderDetails, statusOptions} from '../_model'
import axios from 'axios'
import toast from 'react-hot-toast'
import {BASE_URL} from '../../config'
import {useEffect} from 'react'
import {handleAxiosError} from '../../../utils/helperFunction/_helper'

const UPDATE_STATUS_URL = `${BASE_URL}/api/protect/updateRouteRoleStatus`

type Props = {
  selctedRole: IRouteSenderDetails | null
}

const UpdateRouteRoleStatus = ({selctedRole}: Props) => {
  const queryClient = useQueryClient()

  const {mutateAsync: changeRolesStatusType} = useMutation({
    mutationFn: async (data: {status: number}) => {
      const response = await axios.put(
        `${UPDATE_STATUS_URL}?status=${data.status}&altId=${selctedRole?.altId}`
      )
      console.log(response)
    },
    onSuccess: () => {
      toast.dismiss()
      toast.success('Successfully updated & Getting updated data..')
      queryClient.invalidateQueries(['createRouteSenderRoles'])
      resetForm()
    },
    onError: (error: Error) => {
      toast.dismiss()
      const message = handleAxiosError(error)
      toast.error(message)
    },
  })

  const formik = useFormik({
    initialValues: {
      status: '',
    },
    onSubmit: async (values) => {
      try {
        toast.loading('Processing..')
        const status = values.status.toLowerCase() === 'active' ? 1 : 0

        await changeRolesStatusType({status})
      } catch (error) {
        console.error(error)
      }
    },
  })

  const resetForm = () => formik.resetForm()

  useEffect(() => {
    if (selctedRole) {
      const status = selctedRole.status === 1 ? 'Active' : 'Inactive'
      formik.setFieldValue('status', status)
    }
  }, [selctedRole])

  return (
    <div className='modal fade' tabIndex={-2} id='kt_modal_2'>
      {/* begin::Modal dialog */}
      <div className='modal-dialog modal-dialog-centered modal-lg p-12'>
        {/* begin::Modal content */}
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>Change Status</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              //   onClick={onClose}
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>
          {/* begin::Modal body */}
          <div className='modal-body scroll-y my-5 mx-10'>
            <form onSubmit={formik.handleSubmit}>
              <div className='fv-row mb-7'>
                <label className='fw-semibold fs-6 mb-2'>Status</label>

                <ReactSelectBox
                  formik={formik}
                  fieldValue='status'
                  placeholder='Select value'
                  options={statusOptions}
                />
              </div>
              <div className='text-center pt-15'>
                <button
                  type='reset'
                  className='btn btn-light me-3'
                  data-kt-users-modal-action='cancel'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                  onClick={resetForm}
                >
                  Discard
                </button>

                <button
                  type='submit'
                  className='btn btn-primary'
                  data-kt-users-modal-action='submit'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  <span className='indicator-label'>Change</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpdateRouteRoleStatus
